"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("./curry"));
var _enforceFunction2 = _interopRequireDefault(require("./internal/_enforceFunction"));
var _enforceInterval2 = _interopRequireDefault(require("./internal/_enforceInterval"));
function debounceImmediate(interval, operation) {
  (0, _enforceInterval2.default)(interval);
  (0, _enforceFunction2.default)(operation);
  let timer = null;
  let lastArgs;
  let lastCall = 0;
  let lastResult;
  function cancel() {
    clearTimeout(timer);
    timer = null;
  }
  function runner() {
    cancel();
    lastCall = Date.now();
    lastResult = operation(...lastArgs);
    return lastResult;
  }
  function immediatelyDebounced(...args) {
    lastArgs = args;
    if (timer) {
      cancel();
    }
    if (Date.now() - lastCall >= interval) {
      runner();
    } else {
      timer = setTimeout(runner, interval);
    }
    return lastResult;
  }
  immediatelyDebounced.cancel = cancel;
  return immediatelyDebounced;
}

/**
 * `operation` is called immediately and then `interval` milliseconds after the most
 * recent call.
 *
 * @param  {number} interval of milliseconds
 * @param  {Function} operation
 * @return {any} the most recent result of `operation`
 */
var _default = exports.default = (0, _curry.default)(debounceImmediate);
module.exports = exports.default;